import { Alert, Typography } from '@mui/material';

export const MarkupInfoAlert = () => {
  return (
    <Alert
      severity='info'
      sx={{
        alignItems: 'center',
      }}
    >
      <Typography variant='body2'>
        To add dynamic phone number or membership ID, use{' '}
        <Typography component='span' variant='body2' fontWeight='bold' whiteSpace='nowrap'>
          {`{{ membership.phone_number }}`}
        </Typography>{' '}
        and/or{' '}
        <Typography component='span' variant='body2' fontWeight='bold' whiteSpace='nowrap'>
          {`{{ membership.id }}`}
        </Typography>
        . Cannot be added to title or custom data.
      </Typography>
    </Alert>
  );
};
